// @ts-strict-ignore
import { PropertyValueVO, PropertyVO } from '@project/components/article/model/vo/property.vo';
import { IOperation } from '@shared/undo/operation/i-operation';
import { BasePropertyOperation } from './base-property-operation';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ConnectionUtils } from '@3d-scene/model3d/util/connection-utils';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';

export class ChangePropertyValuesOperation extends BasePropertyOperation implements IOperation {
  private _connectionName: string;
  private _article: ArticleVO;

  constructor(
    property: PropertyVO,
    propertyType: string,
    private _oldValues: PropertyValueVO[],
    private _newValues: PropertyValueVO[],
    projectModel: ProjectModel,
    connectionUtils: ConnectionUtils,
    adminService: AdminService,
  ) {
    super(property, propertyType, projectModel, connectionUtils, adminService);
  }

  public setConnectionInformation(connectionName: string, article: ArticleVO): void {
    this._connectionName = connectionName;
    this._article = article;
  }

  public getQualifiedClassName(): string {
    return 'ChangePropertyValuesOperation';
  }

  public async performRedo(): Promise<void> {
    this.performChangePropertyValuesOperation(this._newValues);
  }

  public async performUndo(): Promise<void> {
    this.performChangePropertyValuesOperation(this._oldValues);
  }

  private performChangePropertyValuesOperation(values: PropertyValueVO[]): void {
    this.changePropertyValues(values);
    if (this._connectionName && this._article) {
      this.connectionUtils.updateInternalConnectionPropertiesByName(this._connectionName, this._article);
    }
  }

  public getOperationDescription(): string {
    return 'changePropertyValuesOperation.description';
  }
}
